import { CoordinatorService } from './coordinator.service';
import { Dataset } from './dataset';
import { ScriptResource } from './script-resource';
import { ScriptDatabin } from './script-databin';
import { ScriptHitset } from './script-hitset';
import { XItem } from './x-item';
import { ScriptBase } from './script-base';
import { ScriptItem } from './script-x-item';

type _FIRST_ARG = ScriptHitset | ScriptDataset | ScriptDatabin | ScriptResource;
type FIRST_ARG = _FIRST_ARG;
type XITEM_TYPE = { [key: string]: any };

export class ScriptDataset extends ScriptBase {
    #coords: CoordinatorService;
    #_dataset: Dataset;

    constructor(coords: CoordinatorService, _dataset: Dataset) {
        super(coords, _dataset);
        this.#coords = coords;
        this.#_dataset = _dataset!;
    }

    get isPreview() {
        return this.#_dataset.isPreview;
    }

    hitset(isPreview = false) {
        const nH = this.#coords.script$.hitset(isPreview);
        return this._hitset(nH, this.#_dataset.mainIdSet, this.isPreview);
    }

    display(isPreview = false) {
        this.hitset(isPreview).display();
        return this;
    }

    search(arg1: string, arg2?: string) {
        return this.#coords.script$.search(arg1, arg2, this.isPreview);
        // return this.hitset(this.isPreview).and(arg1, arg2);
    }

    and(arg1: any, arg2?: any) {
        return this.hitset(this.isPreview).and(arg1, arg2);
    }
    or(arg1: any, arg2?: any) {
        return this.hitset(this.isPreview);
    }

    not(arg1: any, arg2?: any) {
        return this.hitset(this.isPreview).not(arg1, arg2);
    }

    clear() {
        this.#_dataset.clear();
        this.#_dataset.requestReduplicate();
    }

    add(arg: XITEM_TYPE | XITEM_TYPE[] | FIRST_ARG) {
        this._run(arg);
        return this;
    }
    remove(arg: XITEM_TYPE | XITEM_TYPE[] | FIRST_ARG) {
        this._run(arg, true);
        return this;
    }

    items(): ScriptItem[] {
        return this.#_dataset.mainXitemLs.map((xitm: XItem) => new ScriptItem(this.#coords, xitm));
    }

    get idSet() {
        return this.#_dataset.mainIdSet;
    }

    get keys() {
        return this.#_dataset.keys;
    }
    private _run(arg: XITEM_TYPE | XITEM_TYPE[] | FIRST_ARG, isDelete = false) {
        if (this.isPreview) return;
        const d$ = this.#coords.dataset$;
        const xitemLs: XItem[] = [];
        const deleteIdLs: string[] = [];

        if ((arg as any).hitset instanceof Function) {
            if (isDelete) {
                const h = (arg as any).hitset();
                h.idSet.forEach((id: string) => {
                    deleteIdLs.push(id);
                });
            } else {
                const h = (arg as any).hitset(true);
                const kSet = this.#_dataset.keys;
                h.idSet.forEach((id: string) => {
                    const xitm = d$.preview.get(id)!;
                    for (const k of xitm.keys) if (kSet.has(k)) return;
                    xitemLs.push(xitm);
                });
            }
        } else {
            if (!Array.isArray(arg)) arg = [arg];
            if (isDelete) {
                const s = new Set<string>();
                arg.forEach((x: string) => {
                    const rH = this.search(x);
                    rH.idSet.forEach((id: string) => s.add(id));
                });
                deleteIdLs.push(...s);
            } else {
                arg.map((x: XITEM_TYPE) => {
                    x['id'] = x['id'] || this.#coords.uniqueId();
                    xitemLs.push(new XItem(this.#coords, x));
                });
            }
        }
        if (isDelete) {
            d$.main.deleteXitemIdLs(deleteIdLs);
        } else {
            this.#_dataset.importXitemLs(xitemLs);
        }
    }

    log(prefix = 'DATASET') {
        const t = this.#_dataset.isPreview ? 'Preview' : 'Collection';
        console.log(`${prefix}: ${t}, SIZE: ${this.#_dataset.size}`);
        return this;
    }
}
